<template>
  <div>
    <div class="d-flex justify-content-between mb-3">
      <div class="title">Attachments</div>
      <div class="d-flex">
        <button class="mr-2 btn btn-info btn-sm" @click="downloadAllAttachments" v-if="userCanEdit && (attachments.length || boardsWithAttachments.length)">
          <i class="far fa-download icon-left mr-2"></i>
          Download all Attachments
        </button>
        <UploadAttachment v-if="userCanEdit" :isSmallButton="true" :label="'Add Attachment'" :destination="'SpecialOccurrence'" :destinationId="occId" />
      </div>
    </div>
    <div v-if="attachments.length === 0">
      Currently there are no files attached to this Special Occurrence. To add a file click on "Add Attachment"
    </div>
    <AttachmentView :header="''" :destinationId="occId" :destination="'SpecialOccurrence'" :attachments="attachments" :read-only="!userCanEdit" />

    <div class="title mb-4 mt-4" v-if="boardsWithAttachments.length">Attachments from Tasks</div>

    <div v-for="board of boardsWithAttachments" :key="board.boardId">
      <div class="title mb-3">{{board.boardTitle}}</div>
      <div v-for="item of board.items.filter(_ =>_.attachments.length)" :key="item.id">
        <div class="row mb-4">

          <div class="col-8">
            <AttachmentView :header="''" :canDelete="false" :destinationId="occId" :destination="'SpecialOccurrence'" :attachments="item.attachments" />
          </div>
          <div class="col-3">
            <task-card :item="item" :isSO="true" :minimal="true"></task-card>
          </div>
        </div>
        <hr>
      </div>
    </div>
    <router-view></router-view>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import Component from "vue-class-component";
import { SpecialOccurrenceModule, SpecialOccurrenceStore } from "@/store/specialOccurrence";
import { AttachmentsModule, AttachmentsStore } from "@/store/attachments";
import AttachmentView from "@/components/Attachments/AttachmentView.vue";
import UploadAttachment from "@/components/Attachments/UploadAttachment.vue";
import {
  AttachmentDestination,
  SpecialOccurrenceAccessLevel,
  SpecialOccurrenceBoardDto
} from "@/apiclient/apiclient_generated";
import TaskCard from "@/components/TaskCard.vue";
import { attachmentClient } from "@/apiclient/opsboardapi";
import FileSaver from "file-saver";

@Component({
    components: {
      TaskCard,
      UploadAttachment,
      AttachmentView,
    },
  })
  export default class SpecialOccurrenceAttachments extends Vue {
    private store: SpecialOccurrenceModule = SpecialOccurrenceStore;
    private attachmentstore: AttachmentsModule = AttachmentsStore;

    private get occId() {
      return this.$route.params.occId;
    }

    created() {
      this.attachmentstore.loadOccurrenceAttachments(this.$route.params.occId);
      this.store.getSOBoards(this.$route.params.occId);
    }

    get boardsWithAttachments(): SpecialOccurrenceBoardDto[] {
      const boardsWithAttachments = this.store.soBoards.filter( _=> _.items.filter(item => item.attachments.length).length);
      return this.lodash.orderBy(boardsWithAttachments, 'boardTitle');
    }

    get userCanEdit() {
      return this.store.currentOccurrenceUserAccessLevel == SpecialOccurrenceAccessLevel.Admin || this.store.currentOccurrenceUserAccessLevel == SpecialOccurrenceAccessLevel.Editor;
    }

    async downloadAllAttachments() {
      const fileData = await attachmentClient.downloadAllAttachments(this.occId, AttachmentDestination.SpecialOccurrence);
      FileSaver.saveAs(fileData.data, fileData.fileName);
    }

    private get attachments() {
      return this.attachmentstore.occurrenceAttachments;
    }
  }
</script>

<style scoped lang="scss">
  .title {
    font-weight: bold;
    font-size: 1.1rem;
    text-decoration: none;
  }
</style>
